module.exports = __webpack_public_path__ + "img/beab6b8.png";